import { render, staticRenderFns } from "./OperaMemberCouponWindow.vue?vue&type=template&id=237e4920&scoped=true&"
import script from "./OperaMemberCouponWindow.vue?vue&type=script&lang=js&"
export * from "./OperaMemberCouponWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaMemberCouponWindow.vue?vue&type=style&index=0&id=237e4920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e4920",
  null
  
)

export default component.exports